import React, { useEffect, useState } from 'react';
import { Form, Input, Select } from 'antd';

const { Option } = Select;
const { TextArea } = Input;

export default function PeremeshchenieVDrugoeRO(props) {
    const { auth, object } = props;
    const [regionalnieOtdeleniya, setRegionalnieOtdeleniya] = useState([]);

    useEffect(() => {
        auth.fetch('/api/query/RegionalnieOtdeleniya?s-nazvanie').then(res => {
            if (res && res.data) {
                setRegionalnieOtdeleniya(res.data);
            }
        });
    }, []);
 
    const options = regionalnieOtdeleniya.map(i => (
        <Option key={i.ID} value={i.ID}>{i.nazvanie}</Option>
    ));

    return (
        <Form
            form={props.form}
            onFinish={props.submit}
            labelAlign={"left"}
            layout={"vertical"}
            initialValues={{
                shkolaID: object.ID
            }}
        >
            <Form.Item
                name={"novoeROID"}
                label={"Новое региональное отделение"}
                rules={[{ required: true, message: 'Укажите новое региональное отделение!' }]}
            >
                <Select showSearch autoComplete="off" 
                    filterOption={(input, option) =>
                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }>
                    {options}
                </Select>
            </Form.Item>
            {/* <Form.Item
                preserve={"true"}
                hidden={true}
                name={"shkolaID"}
                label={"Школа"}
                rules={[{ required: true, message: 'Укажите школу!' }]}
            >
                <Input disabled />
            </Form.Item> */}
            <Form.Item
                name={"kommentarii"}
                label={"Коментарий"}
                rules={[{ required: false, message: 'Укажите коментарий!' }]}
            >
                <TextArea rows={4} />
            </Form.Item>
        </Form>
    );
}
